import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { wakeUpServer } from '../store/serverSlice';

// Poruka uz formu dok server nije spreman (login, registracija, zaboravljena lozinka)
function ServerStatusNotice() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const status = useSelector((state) => state.serverStore.status);
    const isSlow = useSelector((state) => state.serverStore.isSlow);

    if (status === 'ready') return null;

    if (status === 'error') {
        return (
            <div className="bg-red-100 rounded-lg p-3 text-red-700 text-center text-sm my-4">
                {t('server.error')}{' '}
                <button type="button" onClick={() => dispatch(wakeUpServer())} className="font-semibold underline">
                    {t('server.retry')}
                </button>
            </div>
        );
    }

    return (
        <div className="bg-white/70 border border-gray-300 rounded-lg p-3 text-gray-700 text-center text-sm my-4">
            <p>{t('server.starting')}</p>
            {isSlow && <p className="mt-1 text-gray-500">{t('server.slow')}</p>}
        </div>
    );
}

export default ServerStatusNotice;
